import './roster.css';

import { useEffect, useMemo, useState } from "react";
import { getRoster } from "../../api/searchApi";
import { useParams } from "react-router-dom";
import RosterItem from "./rosterItem";
import CsvDownloader from 'react-csv-downloader';
import getCurrentDateTime from '../utils/getCurrentDateTime';
import { roster_columns } from '../utils/columns';
import RosterLinks from './rosterLinks';
import sanitizeCsv from '../utils/sanitizeCsv';

const rosterName = {
    GENERAL: 'General CDE Working Group',
    ALS: 'Amyotrophic Lateral Sclerosis CDE',
    CP: 'Cerebral Palsy CDE',
    CM: 'Chiari I Malformation CDE',
    CMD: 'Congenital Muscular Dystrophy (CMD) CDE',
    EPILEPSY: 'Version 1.0 Epilepsy CDE Working Group',
    FA: 'Friedreich\'s ataxia CDE',
    FSHD: 'Facioscapulohumeral Muscular Dystrophy (FSHD) CDE',
    HEADACHE: 'Version 1.0 Headache CDE Working Group',
    HD: 'Huntington\'s Disease CDE Working Group',
    MITO: 'Version 1.0 Mitochondrial Disease CDE Working Group',
    MMD: 'Myotonic Dystrophy (DM) CDE',
    MS: 'Multiple Sclerosis CDE',
    MECFS: 'Myalgic Encephalomyelitis/Chronic Fatigue Syndrom CDE',
    NEURRHAB: 'NeuroRehab CDE',
    PD: 'Complete Version 1.0 Parkinson\'s Disease CDE Working Group',
    SCI: 'Spinal Cord Injury',
    STROKE: 'Version 1.0 Stroke CDE Working Group',
    SAH: 'Unruptured Cerebral Aneurysms and Subarachnoid Hemorrhage CDE',
    TBI2: 'Version 2.0 Traumatic Brain Injury CDE Working Group',
    TBI4: '2026 Version 3.0 Traumatic Brain Injury CDE Working Group',
    SRC: 'Sport-Related Concussion CDE'
};

export default function Roster() {
    const [roster, setRoster] = useState([]);

    const { diseaseId } = useParams();

    useEffect(() => {
        const doFetch = async () => {
            const results = await getRoster(diseaseId);

            // console.log(results);

            if (!cancelled)
                setRoster(results);
        };

        let cancelled = false;
        doFetch();

        return () => { cancelled = true; }
    }, [diseaseId]);

    const flatRoster = useMemo(() => {
        return sanitizeCsv(roster.flatMap(r => r.rosterItems));
    }, [roster]);

    return (
        <>
            {diseaseId.toUpperCase().startsWith('NMD') ? 
            <RosterLinks /> :
            <CsvDownloader
              style={{marginTop: '20px'}}
              className="link-button"
              text={`Complete ${rosterName[diseaseId.toUpperCase()]} Roster`}
              filename={`${diseaseId.toUpperCase()}-roster_${getCurrentDateTime()}`}
              datas={flatRoster}
              columns={roster_columns}
              wrapColumnChar={'"'}
            />}
            {roster.map(r => {
                return (
                    <div key={r.grpId}>
                        <h3>{r.grpName}</h3>
                        <ul className="roster-list">
                            {r.rosterItems.map(p => {
                                return (
                                    <RosterItem key={p.id} person={p} />
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </>
    );
}